import { render } from "./Item_Batches.vue?vue&type=template&id=db548d28"
import script from "./Item_Batches.vue?vue&type=script&lang=js"
export * from "./Item_Batches.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__